export const APP_CONSTANTS = {
  ROUTE_PATHS: {
    HOME: 'home',
    PRODUCT_CONTENT:'product-content',
    TERMS_CONDITION: 'terms-and-conditions',
    SITEMAP: 'sitemap'
  },
  DEVICE:{
    MOBILE: 'mobile',
    TABLET:'tablet',
    DESKTOP:'desktop'
  },
  THEME:{
    DARK: 'dark',
    LIGHT:'light'
  },
  ANALYTICS: {
    OPEN_REFERENCE: 'Open Reference',
    CLOSE_REFERENCE: 'Close Reference',
    OPEN_TABLE_OF_CONTENTS: 'Open Table of Contents',
    CLOSE_TABLE_OF_CONTENTS: 'Close Table of Contents',
  },
  RECALL: {
    RECALLED: 'recall',
    DECOMMISSIONED: 'decommissioned',
    INAPP: 'inapp',
    UPGRADE: 'upgrade',
  },
  TABLET_MIN_WIDTH: 768,
  TABLET_MAX_WIDTH: 1024,
  HCP: {
    CONTINUE: 'Medical|Pfizer Medical Interstitial|OK',
    CANCEL: 'Medical|Pfizer Medical Interstitial|Cancel'
  },
  PFIZER_HOME_PAGE: 'https://www.pfizer.com'
};
